<template>
  <div>
    <page-heading-info
    title="Jefferson County Probate Court"
    phone="(740) 283-8556"
    fax="(740) 283-8653"
    hours="8:30AM to 4:30PM"
    pobox="PO Box 549"
    floor="4th floor"
    >
      <address-simple
      line1="16001 State Route 7"
      line2="PO Box 549"
      line3="Steubenville, OH 43952"
      ></address-simple>
    </page-heading-info>

    <text-box-title title="General Info">
      <div class="col-md-6 mt-3">
        <p>
          Probate Court is a division of the Courts of Common Pleas in Ohio. Probate Court has exclusive jurisdiction
          over certain special types of cases: estates, guardianships of incompetent persons and minors, name changes
          of adults and minors, and adoptions. The Probate Court also issues marriage licenses,
          approves minor's settlements, establishes conservatorships, and a host of other matters.
        </p>
      </div>

      <div class="col-md-6 mt-3">
        <ul class="list-group list-group-flush">

          <li class="list-group-item">
            <a href="/static/departments/probate_court/Probate-Court-Costs.pdf">
              Court Costs
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/probate_court/PROBATE-LOCAL-RULES.pdf">
              Local Rules
            </a>
          </li>

          <li class="list-group-item">
            <a href="/static/departments/probate_court/PROBATE-COURT-RECORDS-INFO.pdf">
              Records Information
            </a>
          </li>

        </ul>
      </div>
    </text-box-title>

  </div>
</template>

<script>
import PageHeadingInfo from '@/components/layout/PageHeadingInfo.vue'
import AddressSimple from '@/components/display-utils/AddressSimple.vue'
import TextBoxTitle from '@/components/layout/TextBoxTitle.vue'

export default {
  components: {
    PageHeadingInfo,
    AddressSimple,
    TextBoxTitle,
  },
  data () {
    return {}
  }
}
</script>

<style scoped>
  .court-lookup {
    font-size: 1.5em;
    font-weight: bold;
  }

  .court-lookup:hover {
    opacity: 0.7;
  }

</style>
